import { LoadingWrapper } from "@context-providers/loading-state-context";
import { Box } from "@mui/material";
import { neutral } from "@flat-ui";

interface Props {
  /** Buttons shown in table action bar on the left side */
  leftActions?: JSX.Element[];
  /** Buttons shown in table action bar on the right side */
  rightActions: JSX.Element[];
  /** Whether data is loading - automatically handles loading state for all action buttons */
  isLoading?: boolean;
}

/** Shows an action bar on top of tiles (group of cards) */
export function FaroTilesActionBar({
  leftActions = [],
  rightActions = [],
  isLoading = false,
}: Props): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "54px",
        backgroundColor: neutral[50],
        mt: "13px",
        padding: "3px 14px",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {leftActions.map((action, idx) => (
          <Box key={idx}>
            <LoadingWrapper isLoading={isLoading}>{action}</LoadingWrapper>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {rightActions.map((action, idx) => (
          <Box key={idx}>
            <LoadingWrapper isLoading={isLoading}>{action}</LoadingWrapper>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
